import React from "react";
import { Pie } from "react-chartjs-2";

const OrderPaymentMethodDistribution = ({ data }) => {
	const distributionData = () => {
        let labels = Object.keys(data).reduce((p, c) => { p.push(c); return p; }, []).sort();
		return {
			labels: labels.map(c => c + '                                      '),
			datasets: [
				{
					data: labels.map(l => data[l.trim()].count),
					backgroundColor: ["#ff9a9a", "#7bc581", "#7b95c5", "#b67bc5", "#dfdc90", "#000000"],
					hoverOffset: 4,
				},
			],
		};
	};

	return (
		<Pie
			data={distributionData()}
			options={{
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						maxWidth: 200,
						display: true,
						position: "left",
					},
				},
			}}
		/>
	);
};

export default OrderPaymentMethodDistribution;
